module.exports = __webpack_public_path__ + "img/upload.9a7dd131.svg";